@if (isOpen()) {
  <div (click)="onBackdropClick($event)" class="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 animate-fade-in-fast">
    <div class="bg-white rounded-lg shadow-xl w-full max-w-lg p-6 text-slate-800 m-4">
      <div class="flex justify-between items-center mb-6">
        <h2 class="text-2xl font-bold">{{ (tier() ? 'modals.tierForm.titleEdit' : 'modals.tierForm.titleAdd') | translate }}</h2>
        <button (click)="onClose()" class="text-gray-400 hover:text-gray-600" title="Close modal">
          <i class="fa-solid fa-times text-xl"></i>
        </button>
      </div>
      
      <form [formGroup]="tierForm" (ngSubmit)="onSave()">
        <div class="space-y-4">
          
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div class="md:col-span-2">
              <label for="tierName" class="block text-sm font-medium text-gray-700">{{ 'modals.tierForm.name' | translate }}</label>
              <input id="tierName" type="text" formControlName="name" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500 sm:text-sm">
            </div>
            <div>
              <label for="tierIcon" class="block text-sm font-medium text-gray-700">{{ 'modals.tierForm.icon' | translate }}</label>
              <input id="tierIcon" type="text" formControlName="icon" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500 sm:text-sm">
            </div>
          </div>
          
          <div>
            <label for="tierMinPoints" class="block text-sm font-medium text-gray-700">{{ 'modals.tierForm.minPoints' | translate }}</label>
            <input id="tierMinPoints" type="number" formControlName="min_points" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500 sm:text-sm">
          </div>
          
          <div>
            <label for="tierBenefits" class="block text-sm font-medium text-gray-700">{{ 'modals.tierForm.benefits' | translate }}</label>
            <textarea id="tierBenefits" formControlName="benefits" rows="3" [placeholder]="'modals.tierForm.benefitsPlaceholder' | translate" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-emerald-500 focus:border-emerald-500 sm:text-sm"></textarea>
          </div>

        </div>

        <div class="mt-8 flex justify-end space-x-3">
          <button type="button" (click)="onClose()" class="bg-gray-200 text-gray-800 px-4 py-2 rounded-md hover:bg-gray-300 font-semibold transition-colors">{{ 'modals.productForm.cancel' | translate }}</button>
          <button type="submit" [disabled]="tierForm.invalid" class="bg-emerald-600 text-white px-4 py-2 rounded-md hover:bg-emerald-700 disabled:bg-emerald-300 font-semibold transition-colors">{{ 'modals.productForm.save' | translate }}</button>
        </div>
      </form>
    </div>
  </div>
}
